module.exports = __webpack_public_path__ + "static/media/shows.b269d4e1.png";